import { Injectable } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class DirtyFormStateService {
  private trackedForms: NgForm[] = [];
  private trackedReactiveForms: FormGroup[] = [];
  private onSaveCallbacks: Function[] = [];
  private dirtyPage: boolean = false;
  private invalidPage: boolean = false;

  public trackForm(form: NgForm): void {
    if (form) {
      this.trackedForms.push(form);
    }
  }

  public trackReactiveForm(form: FormGroup): void {
    if (form) {
      this.trackedReactiveForms.push(form);
    }
  }

  public setDirtyStatus(isDirty: boolean): void {
    this.dirtyPage = isDirty;
  }

  public setInvalidStatus(isInvalid: boolean): void {
    this.invalidPage = isInvalid;
  }

  public addOnSaveCallback(onSaveCallback: Function): void {
    if (onSaveCallback) {
      this.onSaveCallbacks.push(onSaveCallback);
    }
  }

  public clearService(): void {
    this.trackedForms = [];
    this.trackedReactiveForms = [];
    this.onSaveCallbacks = [];
    this.dirtyPage = false;
  }

  public resetServiceState(): void {
    this.dirtyPage = false;
    this.trackedForms.forEach(trackedForm => {
      trackedForm.form.markAsPristine();
    });
    this.trackedReactiveForms.forEach(trackedform => {
      trackedform.markAsPristine();
    });
  }

  public pageTouched(): void {
    this.dirtyPage = true;
  }

  public pageIsDirty(): boolean {
    let dirty = false;

    this.trackedForms.forEach(form => {
      if (form && (form.dirty || !form.pristine)) {
        dirty = true;
      }
    });
    this.trackedReactiveForms.forEach(form => {
      if (form && form.dirty) {
        dirty = true;
      }
    });

    return dirty || this.dirtyPage;
  }

  public pageIsValid(): boolean {
    let valid = true;

    this.trackedForms.forEach(form => {
      if (form && form.invalid) {


        valid = false;
      }
    });
    this.trackedReactiveForms.forEach(form => {
      if (form && form.invalid) {
        valid = false;
      }
    });


    return valid && !this.invalidPage;
  }

  public triggerSaveCallbacks(): void {
    if (this.onSaveCallbacks) {
      this.onSaveCallbacks.forEach(callback => callback());
    }
  }
}
